import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../network/auth";
import { baseUrl } from "../../../../network/constants/constants";
import axios from "../../../../network/api";
import PaymentTable from "./component/paymentTable";
import DateFilter from "./component/dateFilter";
import { Row, Col, Spinner } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import * as XLSX from "xlsx";
import "./paymentReport.css";
import SearchField from "../../../customComponent/searchField/searchField";



const PaymentReport = () => {
  const [pagination, setPagination] = useState({
    pageSize: 25,
    page: 1,
  });


  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };


  const [paymentReport, setPaymentReport] = useState([]);
  const [forFilterReport, setForFilterReport] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [loading, setLoading] = useState(false);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const fetchPaymentReport = (start_date = null, end_date = null) => {
    setLoading(true);
    axios
      .get(baseUrl + `payment/payment-report/`, {
        params: {
          start_date: start_date || "",
          end_date: end_date || "",
          // page: pagination.page || 1,
          // size: pagination.pageSize || 25
        },
        ...config,
      })
      .then((response) => {
        setPaymentReport(response.data);
        setForFilterReport(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Franchise Error:", error);
        setLoading(false);
      });
  };

  

  const handleFilterPayment = () => {
    if (!paymentReport || paymentReport.length === 0) {
      setSnackbarMessage("No payment records to filter.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (!startDate || !endDate) {
      setSnackbarMessage("Please select both start and end dates.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (paymentReport.length === 0) {
      setSnackbarMessage("No records found within the selected range.");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
    } else {
      setSnackbarMessage("Filters applied successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    fetchPaymentReport(startDate, endDate);
  };

  const exportToExcel = () => {
    const filteredReport = forFilterReport.map(
      ({ booking, business_id, user_id, other_service, ...rest }) => rest
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredReport);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "paymentDetails");
    XLSX.writeFile(workbook, "paymentDetails.xlsx");

    setSnackbarMessage("Excel sheet downloaded successfully.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  const formattedPaymentReport = forFilterReport?.map((payment) => ({
    ...payment,
    created_at: new Date(payment.created_at).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, 
    }),
  }));
  

  const filteredPayment = (formattedPaymentReport || []).filter((booking) =>
    Object.entries(booking || {}).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item?.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      }
  
      if (key === "is_refund") {
        const statusText = value ? "refunded" : "captured";
        return statusText.includes(searchValue.toLowerCase());
      }
  
      return (
        value &&
        value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );
  
  const paymentWithIndex = filteredPayment.map((payment, index) => ({
    ...payment,
    displayIndex: index + 1,
  }));

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    fetchPaymentReport();
    setSnackbarMessage("Filter reset. Showing all data.");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
    setForFilterReport(paymentReport);
  };

  useEffect(() => {
    fetchPaymentReport();
  }, []);

  return (
    <div className="booking-details mt-4">
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row>
            <Col>
            <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
            </Col>
            <Col className="mb-2">
              <DateFilter
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                onExport={exportToExcel}
                onReset={handleReset}
                handleFilterPayment={handleFilterPayment}
              />
            </Col>
          </Row>
          <PaymentTable
            paymentReport={paymentWithIndex}
            startDate={startDate}
            endDate={endDate}
            handleFilterPayment={handleFilterPayment}
            setPagination={setPagination}
          />
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </>
      )}
    </div>
  );
};

export default PaymentReport;














